import { localizeDateTime } from 'obt-common';
import { Typography } from '@spotnana/blocks/src/Typography';
import { FC } from 'react';
import { getDateChangeIndicator } from 'obt-common/date-utils';
import DisruptionDifferenceLabel from '../DisruptionDifferenceLabel';
import { date_container, date_label, date_label_container, days_changed_indicator, strike_through } from './styles';

interface IProps {
  originalDateTime?: string;
  dateTime: string;
  daysChanged: number | null;
}

const FlightSegmentDateTime: FC<IProps> = ({ originalDateTime, dateTime, daysChanged }) => {
  const daysChangedIndicator = getDateChangeIndicator(daysChanged ?? 0);

  const shouldShowDaysChanged = !!daysChanged && daysChanged !== 0;

  return (
    <div css={date_container}>
      {originalDateTime && (
        <Typography variant="body2" color="disabled" css={strike_through}>
          {localizeDateTime(originalDateTime, { timeStyle: 'short', dateStyle: 'full' })}
        </Typography>
      )}

      <div css={date_label_container}>
        <div css={date_label}>
          <Typography variant="header5" as="div" kind="medium" data-testid="date_time">
            {localizeDateTime(dateTime, { timeStyle: 'short', dateStyle: 'full' })}
          </Typography>

          {shouldShowDaysChanged && (
            <div css={days_changed_indicator} data-testid="days_changed">
              {daysChangedIndicator}
            </div>
          )}
        </div>

        {originalDateTime && (
          <div>
            <DisruptionDifferenceLabel originalDate={originalDateTime} date={dateTime} dateFormat="YYYY-MM-DDTHH:mm" />
          </div>
        )}
      </div>
    </div>
  );
};

export default FlightSegmentDateTime;
